import { gql, useQuery } from '@apollo/client';
import React from 'react';

import { ViewSchemaModal } from 'src/components/viewSchemaModal/ViewSchemaModal';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

interface Props {
  graphId: string;
  onClose: () => void;
  launchId: string;
  graphVariant: string;
}

export const FetchAndViewSchemaModalQuery = gql<
  GraphQLTypes.FetchAndViewSchemaModalQuery,
  GraphQLTypes.FetchAndViewSchemaModalQueryVariables
>`
  query FetchAndViewSchemaModalQuery(
    $graphId: ID!
    $graphVariant: String!
    $launchId: ID!
  ) {
    service(id: $graphId) {
      id
      variant(name: $graphVariant) {
        id
        launch(id: $launchId) {
          id
          build {
            id
            result {
              __typename
              ... on BuildSuccess {
                coreSchema {
                  coreHash
                  coreDocument
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const FetchAndViewSchemaModal = ({
  graphId,
  onClose,
  graphVariant,
  launchId,
}: Props) => {
  const { data, loading } = useQuery(FetchAndViewSchemaModalQuery, {
    variables: {
      graphId,
      graphVariant,
      launchId,
    },
    pollInterval: 5000,
  });

  const launch = data?.service?.variant?.launch;
  const supergraphSdl =
    launch?.build?.result?.__typename === 'BuildSuccess'
      ? launch.build.result.coreSchema.coreDocument
      : null;

  return (
    <ViewSchemaModal
      isOpen
      sdl={supergraphSdl}
      graphId={graphId}
      onClose={onClose}
      isCsdl={true}
      loading={loading}
    />
  );
};
